<div class="dialog-container">
  <h2 class="title">{{ item.nombre }}</h2>

  <img
    class="product-img"
    [src]="item.imageUrl || 'assets/images/no-image.png'"
  />

  <p class="price">${{ item.precioBase }}</p>

  <h3 class="section-title">CANTIDAD</h3>

  <div class="quantity-selector">
    <button (click)="cambiarCantidad(-1)">−</button>
    <span>{{ item.cantidad }}</span>
    <button (click)="cambiarCantidad(1)">+</button>
  </div>

  <h3 class="section-title" *ngIf="item.categoriaID != 5">EXTRAS</h3>

  <div class="extras" *ngIf="!loading && item.categoriaID != 5">
    <div class="extra-row" *ngFor="let topping of toppings">
      <div class="extra-info">
        <span>{{ topping.name }}</span>
        <small>${{ topping.price }}</small>
      </div>

      <mat-checkbox
        [(ngModel)]="topping.seleccionado"
        (change)="calcularTotal()"
      >
      </mat-checkbox>
    </div>
  </div>

  <h3 class="section-title">NOTAS ADICIONALES</h3>

  <textarea
    [(ngModel)]="item.nota"
    placeholder="Escribe aquí..."
    style="width: 80%; align-self: center"
  ></textarea>

  <div class="footer">
    <p class="total">Total: ${{ total }}</p>

    <button class="confirm" (click)="guardar()">AGREGAR AL PEDIDO</button>
  </div>
</div>
